module.exports = __webpack_public_path__ + "src/assets/img/menu_icon_2_green.40ed11db.svg";